import { render } from "./Organization.vue?vue&type=template&id=2293cf50&scoped=true&ts=true"
import script from "./Organization.ts?vue&type=script&lang=ts"
export * from "./Organization.ts?vue&type=script&lang=ts"

import "./Organization.scss?vue&type=style&index=0&id=2293cf50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2293cf50"]])

export default __exports__